import api from 'services/api';

export const getSearchData = async () =>
  api.get('https://run.mocky.io/v3/2e10725a-3495-4040-823e-cc1f102c5770');
